/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_PercentInputs */

const cs_deal_splits_percent = /** @type {(inputs: Deal_Splits_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procento (%)`)
};

const en_deal_splits_percent = /** @type {(inputs: Deal_Splits_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percent (%)`)
};

/**
* | output |
* | --- |
* | "Percent (%)" |
*
* @param {Deal_Splits_PercentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_percent = /** @type {((inputs?: Deal_Splits_PercentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_PercentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_percent(inputs)
	return cs_deal_splits_percent(inputs)
});